// AdryX theme JS
document.addEventListener('DOMContentLoaded', function() {
  // Variant selector
  const selects = document.querySelectorAll('select[name^="options"]');
  selects.forEach(function(select) {
    select.addEventListener('change', function() {
      const form = select.closest('form');
      if (!form) return;
      const options = Array.from(form.querySelectorAll('select[name^="options"]')).map(s => s.value);
    });
  });
});
